import useCartoPiaToken from 'api/hooks/useCartoPiaToken';
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState
} from 'react';

const CartoPiaAuthContext = createContext();

const CartoPiaAuthProvider = ({ children }) => {
  const { data: cartoPiaToken, status: cartoPiaTokenLoadingStatus, refetch: refetchCartoPiaToken } = useCartoPiaToken();

  const cartoPiaAuthToken = ()=> {
    return localStorage.getItem('cartoPiaAuthToken');
  }

  useEffect(() => {
    const updateCartoPiaAuthTokenInLocalStorage = (token) => {
      localStorage.setItem('cartoPiaAuthToken', token.accessToken);
      localStorage.setItem('cartoPiaAuthTokenDate', token.expirationDate);
    };

    const handleTokenUpdate = (token) => {
      updateCartoPiaAuthTokenInLocalStorage(token);
    };

    if (cartoPiaTokenLoadingStatus === 'success' && cartoPiaToken) {
      handleTokenUpdate(cartoPiaToken);
    } else if (cartoPiaTokenLoadingStatus === 'error') {
      refetchCartoPiaToken().then(({ data, status }) => {
        if (status === 'success'&&data) {
          handleTokenUpdate(data);
        }
      });
    }
  }, [cartoPiaToken, cartoPiaTokenLoadingStatus, refetchCartoPiaToken]);

  // A prueba de Alejandro
  useEffect(() => {
    let expirationDate = localStorage.getItem('cartoPiaAuthTokenDate');
    if (!expirationDate) return;
    expirationDate = new Date(expirationDate);
    if (expirationDate > Date.now()) return ;
    const interval = setInterval( () => {
      refetchCartoPiaToken();
    },120000 )
    return () => clearInterval(interval);
  }, []);

  const getCartoPiaAuthenticationToken = useCallback(async () => {
    const localToken = localStorage.getItem('cartoPiaAuthToken');
    const expirationDateStr = localStorage.getItem('cartoPiaAuthTokenDate');
    const expirationDate = new Date(expirationDateStr);

    const isExpired = !expirationDateStr || expirationDate < Date.now();

    if (isExpired) {
      localStorage.removeItem('cartoPiaAuthToken');
      localStorage.removeItem('cartoPiaAuthTokenDate');

      const res = await refetchCartoPiaToken();
      if (res?.accessToken) {
        localStorage.setItem('cartoPiaAuthToken', res.accessToken);
        localStorage.setItem('cartoPiaAuthTokenDate', res.expirationDate);
        return res.accessToken;
      }
      return '';
    }

    if (localToken) {
      return localToken;
    }

    if (!cartoPiaAuthToken) {
      const res = await refetchCartoPiaToken();
      if (res?.accessToken) {
        localStorage.setItem('cartoPiaAuthToken', res.accessToken);
        localStorage.setItem('cartoPiaAuthTokenDate', res.expirationDate);
        return res.accessToken;
      }
      return '';
    }

    return cartoPiaAuthToken;
  }, [refetchCartoPiaToken, cartoPiaAuthToken]);

  const value = useMemo(
    () => ({
      getCartoPiaAuthenticationToken,
    }),
    [getCartoPiaAuthenticationToken]
  );

return <CartoPiaAuthContext.Provider value={value}>{children}</CartoPiaAuthContext.Provider>;

};

const useAuthCartoPia = () => useContext(CartoPiaAuthContext);

export { CartoPiaAuthContext, useAuthCartoPia };
export default CartoPiaAuthProvider;
